import React, { useEffect, useState } from "react"
import Map from "./LocationMap"
import { fromInfo, trans } from "../../../../_providers/Translation"

//styles
import "../../../../assets/css/leeflet.css"
import Help from "../../../partials/Help"
import { BarChart } from "@mui/x-charts/BarChart"
import Api from "@/_helpers/Api"
import Skeleton from "react-loading-skeleton"

const STATUSES = [
  {
    name: trans("tabs.completed"),
    color: "#35B084",
  },
  {
    name: trans("random.remaining"),
    color: "#C5CAE9",
  },
]
export default function BonusPolicies() {
  const [state, setState] = useState({
    loading: true,
    employees: [],
    completed: [],
    uncompleted: [],
  })

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }))

    Api.get("dashboard/employees/targets-forecast")
      .then((res) => {
        const employees = res.data.chart_format || []

        setState((prev) => ({
          ...prev,
          employees: employees.map((e) => e.name),
          forecastDates: employees.map((e) => e.forecast_date || ""),
          completed: employees.map((e) => e.completed || 0),
          uncompleted: employees.map((e) => e.remaining || 0),
          completedPercent: employees.map((e) => e.completed_percent || 0),
          uncompletedPercent: employees.map((e) => e.remaining_percent || 0),
        }))
      })
      .finally(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  return (
    <div className="employees-reservations-chart">
      <div className="head">
        <h3>{trans("headings.lastAddedBonusPolicy")}</h3>
        <ul>
          {STATUSES.map((status) => (
            <li key={status.name}>
              <span style={{ background: status.color }}></span>
              {status.name}
            </li>
          ))}
        </ul>
      </div>
      <hr />
      {state.loading ? (
        <Skeleton count={1} height={300} />
      ) : state.employees.length === 0 ? (
        <div
          className="alert info"
          style={{
            width: "100%",
            marginBottom: "auto",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <BarChart
          xAxis={[
            {
              scaleType: "band",
              data: state.employees,
            },
          ]}
          series={[
            {
              data: state.completed,
              label: STATUSES[0].name,
              stack: "tasks",
              color: STATUSES[0].color,
            },
            {
              data: state.uncompleted,
              label: STATUSES[1].name,
              stack: "tasks",
              color: STATUSES[1].color,
              valueFormatter: (value, context) => {
                const date = state.forecastDates[context.dataIndex] || ""
                return `${value} (${trans("random.forecastEndDate")}: ${date})`
              },
            },
          ]}
          height={300}
          borderRadius={8}
          slotProps={{
            legend: { hidden: true },
          }}
        />
      )}
    </div>
  )
}
